import { Box, Text } from '@factorialco/deprecated-design-system'

interface SectionHeaderProps {
  title: string
}

export const SectionHeader = ({ title }: SectionHeaderProps) => (
  <Box gap="s16">
    <Text color="grey1000" size="400" weight="medium">
      {title}
    </Text>
  </Box>
)
